module.exports = __webpack_public_path__ + "static/media/Tokopedia.a58acb8c.png";